import { TableTemplate } from 'types/tableTemplate';

export const hospitalTableTemplate: TableTemplate[] = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 80,
  },
  {
    id: 'company_name',
    description: 'Razão social',
    originalId: 'company_name',
    width: 300,
  },
  {
    id: 'company_trade_name',
    description: 'Nome Fantasia',
    originalId: 'company_trade_name',
    width: 300,
  },
  {
    id: 'document_number',
    description: 'CNPJ',
    originalId: 'document_number',
    width: 130,
  },
  {
    id: 'email',
    description: 'E-mail',
    originalId: 'email',
    width: 120,
  },
  {
    id: 'phone',
    description: 'Telefone',
    originalId: 'phone',
    width: 120,
  },
  {
    id: 'formattedStreet',
    description: 'Endereço',
    originalId: 'formattedStreet',
    width: 150,
  },
  {
    id: 'formattedCity',
    description: 'Cidade',
    originalId: 'formattedCity',
    width: 140,
  },
  {
    id: 'formattedState',
    description: 'UF',
    originalId: 'formattedState',
    width: 70,
  },
  {
    id: 'formattedActive',
    description: 'Ativo',
    originalId: 'formattedActive',
    width: 200,
  },
];
